import MarcaVehiculoView from "../views/MarcaVehiculoView.vue";
import DashboardLayout from "@/layouts/DashboardLayout.vue";
import ModelosView from "../views/ModelosView.vue";
const routes = [
  {
    path: "/vehiculos",
    component: DashboardLayout,
    children: [
      {
        path: "marca",
        name: "MarcaVehiculos",
        component: MarcaVehiculoView,
        meta: {
          permissions: "baret_navbar:marcasVehiculos",
        },
      },
      {
        path: "modelos",
        name: "ModelosVehiculos",
        component: ModelosView,
        meta: {
          permissions: "baret_navbar:modelosVehiculos",
        },
      },
    ],
  },
];

export default routes;
